/* 🤖 this file was generated by svg-to-ts */
export const matIconCheckBoxOutlineBlank: {
  name: 'check-box-outline-blank';
  data: string;
} = {
  name: 'check-box-outline-blank',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"/></svg>`
};
